import colors from "@Common/assets/colors";
import { useGeneratorContext } from "@Context/GeneratorContext";
import { useTestCaseContext } from "@Context/TestCaseContext";
import { parseTestCases } from "@Generator/history/PubColumn";
import { RevisionHistory as Rev, TestCaseProp } from "@Models/types";
import { useEffect, useState } from "react";
import { MoonLoader } from "react-spinners";

interface Props {
  id: string;
}

const RevisionHistory: React.FC<Props> = ({ id }) => {
  const [revision, setRevision] = useState<Rev | null>(null);
  const [loading, setLoading] = useState(false);

  const { getRevisionHistory } = useGeneratorContext();
  const { selectedGenerated, setSelectedGenerated } = useTestCaseContext();

  useEffect(() => {
    setLoading(true);
    getRevisionHistory(id)
      .then((res) => {
        setRevision(res);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const testcases = parseTestCases(selectedGenerated!.completion_result);

  if (revision === null) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <MoonLoader size={100} color={colors.primary[700]} />
        <label className="mt-2 animate-pulse">Fetching Revision History</label>
      </div>
    );
  }

  const isAdded = (testCase: TestCaseProp) => {
    return testcases.some((tc) =>
      tc.GeneratedTestCase.some((g) => g.title === testCase.title),
    );
  };

  const handleAdd = (item: TestCaseProp, name: string) => {
    if (selectedGenerated) {
      const updatedTestCases = [...testcases];
      const targetTestCase = updatedTestCases.find((tc) => tc.name === name);

      console.log("TESTING: ", targetTestCase);

      if (targetTestCase) {
        targetTestCase.GeneratedTestCase.push(item);
      } else {
        updatedTestCases.push({
          name: "New Test Case",
          reference_num: "N/A",
          GeneratedTestCase: [item],
        });
      }

      setSelectedGenerated({
        ...selectedGenerated,
        completion_result: JSON.stringify(updatedTestCases),
      });
    }
  };

  return (
    <div className="flex h-full w-full flex-col items-center p-4">
      {loading ? (
        <div className="flex h-full w-full flex-col items-center justify-center">
          <MoonLoader size={100} color={colors.primary[700]} />
          <label className="mt-2 animate-pulse">
            Fetching Revision History
          </label>
        </div>
      ) : (
        <div className="flex flex-col gap-y-4">
          {revision &&
            revision.generations.length > 0 &&
            revision.generations.map((gen, index) => (
              <div key={index} className="flex flex-col gap-y-4">
                <label className="font-bold">Generation {index + 1}</label>
                {gen.testCases.map((tc, index) => (
                  <div key={index} className="flex flex-col gap-y-2">
                    <label className="text-xs font-bold">{tc.name}</label>
                    {tc.GeneratedTestCase.map((g, index) => (
                      <div
                        key={index}
                        className="flex flex-row items-center justify-between text-xs"
                      >
                        <label>{g.title}</label>
                        {!isAdded(g) && (
                          <div
                            onClick={() => handleAdd(g, tc.name)}
                            className="cursor-pointer text-primary-500"
                          >
                            ReAdd
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default RevisionHistory;
